export const scrollToId = (id) => {
    const el = document.getElementById(id);
    if (!el) return;
    const lenis = window.__lenis;
    if (lenis && typeof lenis.scrollTo === "function") {
        lenis.scrollTo(el, {
            duration: 1.5,
            easing: (t) => 1 - Math.pow(1 - t, 4),
        });
    } else {
        el.scrollIntoView({ behavior: "smooth" });
    }
};
